import React from 'react'
import { SortDirection } from 'react-virtualized'
import get from 'lodash/get'
import { sort } from 'src/util'

/**
 * Sort data based on parameters
 */
export default function useSortedData({ data, sortBy, sortWith, sortDirection }) {
  // sort data if sortBy is defined
  const sortedData = React.useMemo(
    () => (sortBy ? sort(data, item => (sortWith ? sortWith(item) : get(item, sortBy))) : data),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sortWith, sortBy, data]
  )

  // reverse array order direction if descending and return
  return React.useMemo(
    () => (sortDirection === SortDirection.DESC ? [...sortedData].reverse() : sortedData),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sortDirection, sortedData]
  )
}
